<template>
    <div class="alerts">
        <div class="panel-heading">
            <h3>Recent Medical Notes</h3>
            <div v-if="!isLoading" class="add">
                <img
                    v-if="isLoadingModal"
                    class="spinner"
                    src="assets/ajax-spinner.gif"
                />
                <b-button
                    size="sm"
                    v-else
                    class="btn plus"
                    :disabled="skipFetchData"
                    @click="newMedicalNote"
                >
                    &#43;
                </b-button>
            </div>
        </div>

        <loader v-if="isLoading" />

        <p v-if="!isLoading && isShowError">{{ errorMessage }}</p>

        <div v-if="!isLoading && !isShowError">
            <div v-if="items.length > 0">
                <div class="subheader">
                    <span>Title:</span>
                    <span>Complaint:</span>
                    <span>Date (Provider):</span>
                </div>

                <div
                    v-for="item in items"
                    v-bind:key="item.id"
                    class="item-row"
                >
                    <input type="hidden" name="id" :value="item.id" />
                    <a :href="`/apps/index.php/${item.ci_url}`">{{
                        item.label
                    }}</a>

                    <span>{{ item.complaint }}</span>

                    <span class="date">
                        {{ _carbonDateDisplay(item.date) }}

                        <span v-if="item.prescribed_by">
                            ({{ item.prescribed_by.display_name }})
                        </span>
                        <span v-else-if="item.default_provider">
                            ({{ item.default_provider.display_name }})
                        </span>
                        <span v-else>(-)</span>
                    </span>
                </div>
            </div>
            <div v-else>
                <div class="subheader">
                    <span>Note:</span>
                    <span>Priority:</span>
                </div>
                <p style="margin: 5px 0;">No records available.</p>
            </div>
        </div>

        <modal-new-medical-note
            ref="modalNewMedicalNote"
            :hide-patient-field="true"
        />
    </div>
</template>

<script>
import axios from "axios";
import ModalNewMedicalNote from "@/module/soap/create";

export default {
    components: {
        ModalNewMedicalNote,
        Loader: () => import("@/components/elements/loader-list")
    },
    data: function () {
        return {
            isLoading: true,
            items: [],
            isShowError: false,
            errorMessage: "",
            isLoadingModal: false
        };
    },
    props: {
        skipFetchData: {
            type: Boolean,
            default: false
        },
        patientId: {
            type: String,
            default: null
        },
        permissions: {
            type: Object
        }
    },
    mounted: function () {
        if (this.skipFetchData) {
            this.isLoading = false;
        } else {
            this.fetchData();
        }
    },
    methods: {
        fetchData: async function () {
            try {
                this.isLoading = true;
                this.isShowError = false;

                const res = await axios.get(
                    `${process.env.BARRAMUNDI}record/medical-note/snapshot/${this.patientId}?limit=3`
                );

                this.isLoading = false;

                if (res.data.response.message.code === 200) {
                    this.items = res.data.response.resources;
                }
            } catch (error) {
                this.isLoading = false;
                this.isShowError = true;
                this.errorMessage = "Error: Unable to fetch data.";
            }
        },
        newMedicalNote: function () {
            if (this.skipFetchData) {
                return;
            }

            this.$refs.modalNewMedicalNote.open({
                patientId: this.patientId
            });
        },
        getPriorityLabel: function (type) {
            var mapping = {
                0: "Low",
                1: "Medium",
                2: "High"
            };

            return mapping[type] || "-";
        }
    }
};
</script>

<style scoped>
.alerts {
    margin-bottom: 50px;
}
.panel-heading {
    display: grid;
    grid-template-columns: 1fr 28px;
    background-color: transparent;
    align-items: center;
    margin-bottom: 10px;
}
.panel-heading h3 {
    margin: 0;
    font-size: 1.3em;
}
.panel-heading .add {
    text-align: center;
}
.panel-heading .add .spinner {
    opacity: 0.5;
}
.subheader {
    display: grid;
    grid-template-columns: 1fr 1fr 100px 28px;
}
.subheader span {
    font-weight: bold;
}
.item-row {
    display: grid;
    grid-template-columns: 1fr 1fr 100px 28px;
    border-bottom: 1px solid #ececec;
    padding: 10px 0;
    align-items: flex-start;
}
.item-row .btn.more {
    color: #333;
    padding: 2px 0;
}
.item-row ul.nav-pills li a {
    padding: 5px 0;
}
.options-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.4;
}
.btn.plus,
.btn.more {
    border-radius: 0;
}
.btn.plus {
    font-weight: bold;
    font-size: 1.1em;
}
</style>
